module.exports = __webpack_public_path__ + "img/18.7cf1046a.png";